import React from 'react';
import { scrollToTop } from '../utils/scroll';

interface FooterProps {
  creatorId?: string;
}

const Footer: React.FC<FooterProps> = ({ creatorId }) => {
  const signupPath = creatorId ? `/sign-up/${creatorId}` : '/sign-up';

  return (
    <footer>
      <div className='footer-content'>
        <div className='footer-column'>
          <ul>
            <li>
              <a href="#" className="paragraphs medium color off-white" onClick={scrollToTop}>Back to top</a>
            </li>
            <li>
              <a href={signupPath} className='paragraphs medium color off-white'>Sign up now</a>
            </li>
          </ul>
        </div>  
        <div className='footer-column'>
          <ul>
            <li>
              <a href="http://www.appetiteapp.io/about" className='paragraphs medium color cream' target='_blank' rel="noopener noreferrer">About Appetite</a>
            </li>
            <li>
              <a href="http://www.appetiteapp.io/contact" className='paragraphs medium color cream' target='_blank' rel="noopener noreferrer">Contact Appetite</a>
            </li>
            <li>
              <a href="/privacy-policy" target='_blank' className='paragraphs medium color cream'>Privacy Policy</a>
            </li>
            <li>
              <a href="/terms-and-conditions" target='_blank' className='paragraphs medium color cream'>Terms & Conditions</a>
            </li>
          </ul>
        </div>
        <div className='footer-column'>
          <ul>
            <li>
              <a href="https://www.instagram.com/appetite.theapp/" className='paragraphs medium color cream' target='_blank' rel="noopener noreferrer">Instagram</a>
            </li>
            <li>
              <a href="https://www.tiktok.com/@appetite.theapp" className='paragraphs medium color cream' target='_blank' rel="noopener noreferrer">TikTok</a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/appetite-the-app/" className='paragraphs medium color cream' target='_blank' rel="noopener noreferrer">LinkedIn</a>
            </li>
          </ul>
        </div>
      </div>
      <div className='footer-bottom'>
        <p className='paragraphs small color cream'>© 2024 Appetite. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer; 